import React, { useState } from 'react';
import './DimensionalBreakdowns.css';

export type BreakdownTabId = 'asset' | 'time' | 'performance' | 'exports';

interface BreakdownTab {
  id: BreakdownTabId;
  label: string;
  enabled: boolean;
}

interface DimensionalBreakdownsProps {
  children: (activeTab: BreakdownTabId) => React.ReactNode;
}

const BREAKDOWN_TABS: BreakdownTab[] = [
  { id: 'asset', label: 'By Asset', enabled: true },
  { id: 'time', label: 'By Time', enabled: true },
  { id: 'performance', label: 'By Performance', enabled: true },
  { id: 'exports', label: 'Exports', enabled: true },
];

/**
 * Dimensional Breakdowns Component
 * Provides tab-based navigation for viewing profit data from different perspectives
 */
const DimensionalBreakdowns: React.FC<DimensionalBreakdownsProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<BreakdownTabId>('asset');

  const handleTabClick = (tabId: BreakdownTabId) => {
    setActiveTab(tabId);
  };

  const handleKeyDown = (event: React.KeyboardEvent, tabId: BreakdownTabId) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setActiveTab(tabId);
    }
  };

  return (


<div>
      <nav className="breakdowns-tabs" role="tablist" aria-label="Breakdown dimensions">
        {BREAKDOWN_TABS.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`breakdown-panel-${tab.id}`}
            id={`breakdown-tab-${tab.id}`}
            className={`breakdown-tab ${activeTab === tab.id ? 'active' : ''} ${!tab.enabled ? 'disabled' : ''}`}
            onClick={() => tab.enabled && handleTabClick(tab.id)}
            onKeyDown={(e) => tab.enabled && handleKeyDown(e, tab.id)}
            disabled={!tab.enabled}
            tabIndex={activeTab === tab.id ? 0 : -1}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <div
        role="tabpanel"
        id={`breakdown-panel-${activeTab}`}
        aria-labelledby={`breakdown-tab-${activeTab}`}
        className="breakdown-content"
      >
        {children(activeTab)}
      </div>
</div>
  );
};

export default DimensionalBreakdowns;
